import { render, staticRenderFns } from "./balance_account_record_list.vue?vue&type=template&id=5df2af56&scoped=true"
import script from "./balance_account_record_list.vue?vue&type=script&lang=js"
export * from "./balance_account_record_list.vue?vue&type=script&lang=js"
import style0 from "./balance_account_record_list.vue?vue&type=style&index=0&id=5df2af56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2af56",
  null
  
)

export default component.exports